// src/components/LoggedInLayout.js

import React from 'react';
import { Outlet } from 'react-router-dom';
import LoggedInNav from './LoggedInNav'; // The path for this import is now local

const LoggedInLayout = () => {
  return (
    <div>
      <LoggedInNav />
      <main>
        {/* The child routes (Dashboard, Profile, etc.) will render here */}
        <Outlet /> 
      </main>
    </div>
  );
};

export default LoggedInLayout;